import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage, getLanguages } from 'react-localize-redux';

import * as AppActions from './AppState';
import './App.styl';

import Header from '../../components/Header';
import IncomeInput from '../../components/IncomeInput';
import ChartSection from '../../components/ChartSection';
import Infobox from '../../components/Infobox';
import Info from '../../components/Infobox/info';
import Embed from '../../components/Infobox/embed';
import Footer from '../../components/Footer';


class App extends PureComponent {
  static childContextTypes = {
    getCountryLabel: PropTypes.func
  };

  getChildContext() {
    return {
      getCountryLabel: (id) => {
        const label = this.props.countries.find(country => country.Country_Code === id);
        return label && label[`Country_Label_${this.props.currentLanguage}`];
      }
    };
  }

  componentDidMount() {
    this.props.dispatch(AppActions.loadData(this.props.currentLanguage));
    document.title = this.props.translate('header.main_headline');
  }

  onInfoBoxClose = () => {
    this.props.dispatch(AppActions.setInfoboxMode(''));
  }

  render() {
    return !this.props.loading && (
      <div className="idw__app">
        <Header
          dispatch={this.props.dispatch}
          translate={this.props.translate}
          currentLanguage={this.props.currentLanguage}
        />
        <Infobox
          onClose={this.onInfoBoxClose}
          isActive={this.props.infoboxMode === 'info'}
          component={<Info {...this.props.translate(['info.content'])} />}
        />
        <Infobox
          onClose={this.onInfoBoxClose}
          isActive={this.props.infoboxMode === 'embed'}
          component={<Embed currentLanguage={this.props.currentLanguage} {...this.props.translate(['embed.description'])} />}
        />
        <IncomeInput
          dispatch={this.props.dispatch}
          translate={this.props.translate}
          currentLanguage={this.props.currentLanguage}
          showIncomeSection={this.props.showIncomeSection}
          formulaFactor={this.props.formulaFactor}
        />
        <ChartSection {...this.props} />
        <Footer dispatch={this.props.dispatch} translate={this.props.translate} currentLanguage={this.props.currentLanguage} />
      </div>
    );
  }
}

export default connect(
  state => ({
    ...state.AppState,
    currentLanguage: getActiveLanguage(state.locale).code,
    translate: getTranslate(state.locale),
    languages: getLanguages(state.locale)
  })
)(App);



// WEBPACK FOOTER //
// ./src/modules/App/index.js